import * as v from 'valibot';

const authRegisterPayrollIdSchema = v.object({
  email: v.pipe(
    v.string('Email is required'),
    v.nonEmpty('Email is required'),
    v.email('Invalid email address')
  ),
  payrollId: v.pipe(v.string('Payroll ID is required'), v.nonEmpty('Payroll ID is required')),
  lastName: v.pipe(v.string('Last name is required'), v.nonEmpty('Last name is required')),
});

export default authRegisterPayrollIdSchema;
